import {
	RECEIVE_SETTINGS,
	REQUEST_SETTINGS,
	SETTINGS_ERROR,
	REQUEST_SET_SETTINGS,
	RECEIVE_SET_SETTINGS,
	SET_SETTINGS_ERROR,
} from '../actions/settingsActions';
import { checkIfObjectEmpty } from 'src/utils/helper';

export const initialSettingsState = {
	// here we store the fetching and error info for each setting
	isFetching: {},
	error: {},
	// the settings
	email: {
		init: true,
	},
	menuColor: {
		init: true,
		model_TopBack: '#179c7d',
		model_TopText: '#ffffff',
		model_LeftBack: '#179c7d',
		model_LeftText: '#ffffff',
		admin_TopBack: '#417505',
		admin_TopText: '#B8E986',
		admin_LeftBack: '#417505',
		admin_LeftText: '#B8E986',
	},
	projects: {
		init: true,
		allow: false,
	},
	modelView: {
		allow: true,
		view: false,
		init: true,
	},
	windows: {
		init: true,
		allow: false,
	},
	impressum: {
		init: true,
		content: { en: '', de: '' },
	},
	privacy: {
		init: true,
		content: { en: '', de: '' },
	},
	chatBot: {
		init: true,
		enable: false,
		apiKey: '',
	},
	iks: {
		init: true,
	},
	assessment: {
		init: true,
	},
};

export const settingsReducer = (state = initialSettingsState, action) => {
	switch (action.type) {
		case REQUEST_SETTINGS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: { ...state.isFetching, [action.payload]: true } };
		case RECEIVE_SETTINGS:
			// sets new state and fetching ended
			// console.log(`RECEIVE_SETTINGS for "${action.payload.settingsCategory}"`, {
			// 	payload: action.payload,
			// 	state,
			// });
			if (!action.payload.settingsCategory) return state;

			// if no data is stored yet on backend we just keep the init data & store that we fetched
			if (checkIfObjectEmpty(action.payload.settings)) {
				return {
					...state,
					[action.payload.settingsCategory]: { ...state[action.payload.settingsCategory], init: false },
					isFetching: { ...state.isFetching, [action.payload.settingsCategory]: false },
				};
			}
			return {
				...state,
				[action.payload.settingsCategory]: { ...action.payload.settings, init: false },
				isFetching: { ...state.isFetching, [action.payload.settingsCategory]: false },
			};
		case SETTINGS_ERROR:
			// fetching ended and error is being set
			return {
				...state,
				error: { ...state.error, [action.payload.settingsCategory]: action.payload.error },
				isFetching: { ...state.isFetching, [action.payload.settingsCategory]: false },
			};
		case REQUEST_SET_SETTINGS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: { ...state.isFetching, [action.payload]: true } };
		case RECEIVE_SET_SETTINGS:
			// sets new state and fetching ended
			return {
				...state,
				[action.payload.settingsCategory]: { ...action.payload.settings, init: false },
				isFetching: { ...state.isFetching, [action.payload.settingsCategory]: false },
			};
		case SET_SETTINGS_ERROR:
			// fetching ended and error is being set
			return {
				...state,
				error: { ...state.error, [action.payload.settingsCategory]: action.payload.error },
				isFetching: { ...state.isFetching, [action.payload.settingsCategory]: false },
			};
		default:
			return state;
	}
};
